module.exports = __webpack_public_path__ + "static/media/coach-man.min.e388b17c.webp";